import api from "./api";

const registrationService = {
  // Public (no auth)
  lookupPrn: (prn) => api.post("/registration/public/prn/lookup", { prn }),
  getAvailability: (params) => api.get("/registration/public/availability", { params }),
  getDepartments: (params) => api.get("/registration/public/departments", { params }),
  getClasses: (params) => api.get("/registration/public/classes", { params }),
  submit: (payload) => api.post("/registration/public/submit", payload),
  requestOtp: (prn) => api.post("/registration/public/otp/request", { prn }),
  verifyOtp: (payload) => api.post("/registration/public/otp/verify", payload),
  getRecord: (params) => api.get("/registration/public/record", { params }),
  updateRecord: (payload) => api.put("/registration/public/record", payload),
  lookupByEmail: (email) => api.post("/registration/public/email/lookup", { email }),

  // Staff (auth + RBAC)
  addPrn: (payload) => api.post("/registration/prn", payload),
  listPrns: (params) => api.get("/registration/prn", { params }),
  deletePrn: (id) => api.delete(`/registration/prn/${id}`),
  bulkImportPrns: (formData, config = {}) => api.post("/registration/prn/bulk-import", formData, config),
  setAvailability: (payload) => api.put("/registration/settings/availability", payload),
  getAvailability_staff: (params) => api.get("/registration/settings/availability", { params }),
  listPending: (params) => api.get("/registration/requests", { params }),
  decide: (id, payload) => api.patch(`/registration/requests/${id}/decision`, payload),
  listHistory: (params) => api.get("/registration/requests/history", { params }),
};

export default registrationService;
